import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom';
import { navPath } from './constant';
import Dashboard from './pages/dashboard';
import AdminMonitor from './pages/dashboard/outlet/monitor/monitor';
import UserPanel from './pages/dashboard/outlet/user-panel/user-panel';
import Changelog from './pages/dashboard/outlet/changelog/changelog';
import Loading from './pages/loading';
import Login from './pages/login';
import { Toaster } from '@/components/ui/sonner';
import { ThemeProvider } from 'next-themes';
import ResetPassword from './pages/dashboard/outlet/reset-password';

const App: React.FC = () => {
  return (
    <ThemeProvider attribute='class' defaultTheme='light'>
      <BrowserRouter>
        <Routes>
          <Route path='/' element={<Loading />} />
          <Route path={navPath.login} element={<Login />} />
          <Route path={navPath.dashboard.index} element={<Dashboard />}>
            <Route index element={<Navigate to={navPath.dashboard.monitor.index} replace />} />
            <Route path={navPath.dashboard.monitor.admin} element={<AdminMonitor />} />
            <Route path={navPath.dashboard.userPanel} element={<UserPanel />} />
            <Route path={navPath.dashboard.resetPassword} element={<ResetPassword />} />
            <Route path={navPath.dashboard.changelog} element={<Changelog />} />
          </Route>

          <Route path='*' element={<Loading />} />
        </Routes>
        <Toaster position='top-center' richColors duration={2000} />
      </BrowserRouter>
    </ThemeProvider>
  );
};

export default App;
